"use strict";
// Please see documentation at https://learn.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timer = void 0;
// Write your JavaScript code.
const browser_1 = require("@sentry/browser");
(0, browser_1.init)({
    dsn: 'https://168ca76aee0c6cb96f0a641ccf6610ce@sentry.snerpa.is/45',
    tunnel: '/tunnel',
});
require("htmx.org");
const alpinejs_1 = __importDefault(require("alpinejs"));
const htmx_org_1 = __importDefault(require("htmx.org"));
window.htmx = htmx_org_1.default;
function timer(expiry) {
    var result = {
        expiry,
        remaining: null,
        init() {
            this.setRemaining();
            setInterval(() => {
                this.setRemaining();
            }, 1000);
        },
        setRemaining() {
            const diff = this.expiry.getTime() - new Date().getTime();
            this.remaining = parseInt((diff / 1000).toString());
        },
        days() {
            var _a, _b;
            return {
                value: ((_a = this.remaining) !== null && _a !== void 0 ? _a : 0) / 86400,
                remaining: ((_b = this.remaining) !== null && _b !== void 0 ? _b : 0) % 86400
            };
        },
        hours() {
            return {
                value: this.days().remaining / 3600,
                remaining: this.days().remaining % 3600
            };
        },
        minutes() {
            return {
                value: this.hours().remaining / 60,
                remaining: this.hours().remaining % 60
            };
        },
        seconds() {
            return {
                value: this.minutes().remaining,
            };
        },
        format(value) {
            return ("0" + parseInt(value.toString())).slice(-2);
        },
        time() {
            return {
                days: this.format(this.days().value),
                hours: this.format(this.hours().value),
                minutes: this.format(this.minutes().value),
                seconds: this.format(this.seconds().value),
            };
        },
    };
    return result;
}
exports.timer = timer;
window.countdownTimer = timer;
window.Alpine = alpinejs_1.default;
alpinejs_1.default.start();
